module.exports = __webpack_public_path__ + "static/media/importOrg.13e33004.xlsx";